export const RESET_AUTH_STATE = Symbol('auth/common/RESET_AUTH_STATE');

export const SET_AUTH_PAGE_INITED = Symbol('auth/common/SET_AUTH_PAGE_INITED');
